module.exports = __webpack_public_path__ + "static/media/4.a3544d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/4.png
// module id = 1470
// module chunks = 0